import { render } from "./RegistrationFormCallback.vue?vue&type=template&id=1834537a"
import script from "./RegistrationFormCallback.vue?vue&type=script&lang=js"
export * from "./RegistrationFormCallback.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/royahayefarda-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__